import { render } from "./Tag.vue?vue&type=template&id=46519559&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=46519559&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-46519559"

export default script